import React, { FunctionComponent } from 'react';
import { MenuEntries } from 'utils/Constants/MenuEntries';
import { Menu as MMMenu, MenuLink } from '@missionme/mime_elements';
import { SleepBrandLink } from '../SleepBrandLink/SleepBrandLink';
import { Link, useLocation } from 'react-router-dom';
import { useRouteData } from 'View/Application';

interface IProps {
  noNavigation?: boolean;
  brandLink?: React.ReactNode;
}

export const Menu: FunctionComponent<IProps> = () => {
  const location = useLocation();
  const { currentRoute } = useRouteData();

  return (
    <MMMenu brandLink={<SleepBrandLink />}>
      {currentRoute &&
        !(Object.prototype.hasOwnProperty.call(currentRoute, 'hideMenu') && currentRoute?.hideMenu === true) &&
        MenuEntries.map(({ to, title }, index) => (
          <MenuLink location={location} tag={Link} key={`menuEntry${index}`} to={to}>
            {title}
          </MenuLink>
        ))}
    </MMMenu>
  );
};
